import React, { Component } from "react";
import ArticleItem from "../../../../components/Article/ArticleItem";
import ArticleLine from "../../../../components/Article/ArticleLine";
import { get } from "../../../../utils/request";
import "./style.css";
import "../../../../index.css";
class ArticleKeySearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clickName: "取消",
      name: "",
      articles: [],
    };
  }
  componentDidUpdate() {
    this.textInput.focus();
  }
  render() {
    const { placeholder, visible } = this.props;
    return (
      <div
        className={
          visible === true
            ? "articleKeySearch_box"
            : "articleKeySearch_box display_none"
        }
      >
        <div className="articleKeySearch_box_left fl">
          <div className="articleKeySearch_box_left_div">
            <div className="articleKeySearch_box_left_div_img fl">
              <img
                alt=""
                src={require("../../../../images/search/search_2.png")}
              ></img>
            </div>
            <div className="articleKeySearch_box_left_div_input fl">
              <input
                value={this.state.name}
                onChange={this.handleChang}
                ref={(input) => {
                  this.textInput = input;
                }}
                placeholder={placeholder}
              ></input>
            </div>
            <div
              style={{
                display: this.state.clickName === "搜索" ? "block" : "none",
              }}
              className="articleKeySearch_box_right_div_img fr"
              onClick={() => this.handleRemoveName()}
            >
              <img
                alt=""
                src={require("../../../../images/search/search_3.png")}
              ></img>
            </div>
          </div>
        </div>
        <div className="articleKeySearch_box_right fl">
          <div
            onClick={this.handleCancle}
            className="articleKeySearch_box_right_txt fl"
          >
            取消
          </div>
        </div>
        <div className="clear"></div>
        <div className="articleKeySearch_box_item">
          {this.state.articles.map((item, index) => {
            return (
              <div key={index}>
                <ArticleItem
                  title={item.title}
                  hits={item.hits}
                  titleImg={item.titleImg}
                  articleType={item.articleType}
                  hashId={item.hashId}
                ></ArticleItem>
                <ArticleLine visible={true}></ArticleLine>
              </div>
            );
          })}
          <div style={{height:46}}></div>
        </div>
        
      </div>
    );
  }

  /**
   * 取消操作
   */
  handleCancle = () => {
    this.props.handleAddScroll();
    this.props.handleVisibleSearch();
    this.props.handleShowDataList();
    this.setState({
      clickName: "取消",
      name: "",
      articles: [],
    });
  };
  /**
   * input输入框变化的时候
   */
  handleChang = (e) => {
    this.setState({
      name: e.target.value,
    });
    if (e.target.value.length > 0) {
      this.setState({
        clickName: "搜索",
      });
      get("/public/v1/article/search/prompt/" + e.target.value).then((res) => {
        this.setState({
          articles: res.data,
        });
      });
    } else {
      this.setState({
        clickName: "取消",
        articles: [],
      });
    }
  };
  /**
   * 移除搜索的院校名称
   */
  handleRemoveName = () => {
    this.setState({
      clickName: "取消",
      name: "",
      articles: [],
    });
  };
}

export default ArticleKeySearch;



// WEBPACK FOOTER //
// ./src/containers/ArticleList/components/ArticleKeySearch/index.js